import {connect} from 'react-redux';
import {AnyAction, Dispatch} from 'redux';
import ApprovedApplicationsExportConfirmView from '../components/views/ApprovedApplicationsExportConfirmView';
import {State} from '../../types/mx/reducers';
import {
    ApprovedApplicationsExportConfirmDispatchProps,
    ApprovedApplicationsExportConfirmStateProps
} from '../types/containers';
import * as ApprovedApplicationsActions from '../actions/ApprovedApplicationsActions';
import * as ModalActions from '../../../common/actions/ModalActions';

const mapStateToProps = (state: State): ApprovedApplicationsExportConfirmStateProps => {
    const {isExporting, fileName, url, hasError} = state.approvedApplications.list.export;
    return {isExporting, fileName, url, hasError};
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): ApprovedApplicationsExportConfirmDispatchProps => {
    return {
        onConfirm: () =>
            dispatch(ApprovedApplicationsActions.ON_CONFIRM_EXPORT_APPROVED_APPLICATIONS_ACTION.action()),
        onClose: () => dispatch(ModalActions.CLOSE_MODAL_ACTION.action()),
    };
};

const ApprovedApplicationsExportConfirmContainer = connect(
    mapStateToProps, mapDispatchToProps
)(ApprovedApplicationsExportConfirmView);

export default ApprovedApplicationsExportConfirmContainer;
